import emailAccountApi from "~/api/email_account";

const fetchEmailAccounts = ({ commit, state }) => {
  if (state.fetchingEmailAccounts === false && state.emailAccounts.length === 0) {
    commit("SET_FETCHING_EMAIL_ACCOUNTS", true);

    emailAccountApi
      .paginate(1, 200)
      .then((response) => {
        commit("SET_EMAIL_ACCOUNTS", response.data);
      })
      .finally(() => {
        commit("SET_FETCHING_EMAIL_ACCOUNTS", false);
      });
  }
};

const fetchEmailAccountsByUser = ({ commit, state }, userId) => {
  if (state.fetchingEmailAccounts === false && state.emailAccounts.length === 0) {
    commit("SET_FETCHING_EMAIL_ACCOUNTS_BY_USER", true);

    emailAccountApi
      .getByUser(userId)
      .then((response) => {
        commit("SET_EMAIL_ACCOUNTS_BY_USER", response.data);
      })
      .finally(() => {
        commit("SET_FETCHING_EMAIL_ACCOUNTS_BY_USER", false);
      });
  }
};

const getEmailAccountById = async (context, emailAccountId) => {
  if (context.state.fetchingEmailAccountsIds.indexOf(emailAccountId) !== -1
    || context.getters.hasEmailAccountById(emailAccountId)) {
    return context.getters.getEmailAccountById(emailAccountId);
  }

  context.commit("SET_FETCHING_EMAIL_ACCOUNT_IDS", [emailAccountId]);

  return emailAccountApi.getById(emailAccountId)
    .then((response) => {
      context.commit("UNSET_FETCHING_EMAIL_ACCOUNT_IDS", [emailAccountId]);
      context.commit("CACHE_EMAIL_ACCOUNT", response.data);

      return response.data;
    });
};

const setEmailAccounts = ({ commit }, emailAccounts) => {
  commit("SET_EMAIL_ACCOUNTS", emailAccounts);
};

export default {
  fetchEmailAccounts,
  fetchEmailAccountsByUser,
  getEmailAccountById,
  setEmailAccounts,
};
